<span [class]="'fi fi-' + country" [class.fis]="squared"></span>
